import { QueryFunctionContext } from 'react-query';
import { FILES_PER_ROW, FILE_TYPE } from '../../constant/numericParams';
import {
  IFilesSearchData,
  IFilesSearchInFolder,
} from '../../interfaces/training.interface';
import { tmsHTTPRequest } from '../../services/axios/httpRequest';

export const hardDeleteFile = (id: string) => {
  return tmsHTTPRequest.delete(`/v1/files/hard-delete/${id}`);
};

export const restoreFile = (id: string, data = null) => {
  return tmsHTTPRequest.put(`/v1/files/restore/${id}`, data);
};

export const softDeleteFile = (id: string, data = null) => {
  return tmsHTTPRequest.put(`/v1/files/soft-delete/${id}`, data);
};

export const getFilesInTrash = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/files/get-all-in-trash?FileType=${
      queryKey[1] || FILE_TYPE.Other
    }&PageNumber=${pageParam}&PageSize=${queryKey[2] || FILES_PER_ROW}`
  );
};
export const getFilesInFolder = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/files/in-folder/${queryKey[1]}?FileType=${
      queryKey[2] || FILE_TYPE.Other
    }&PageNumber=${pageParam}&PageSize=${queryKey[3] || FILES_PER_ROW}`
  );
};

export const getAllTMSUser = () => {
  return tmsHTTPRequest.get('/users');
};

const postSearchFiles = (data: IFilesSearchData) => {
  return tmsHTTPRequest.post('/v1/files/search', {
    ...data,
    advancedSearch: { fields: ['Name'] },
  });
};

export const middlewarePostSearchFiles = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return postSearchFiles({
    keyword: queryKey[1],
    pageNumber: pageParam,
    place: queryKey[2],
    fileType: queryKey[3],
    pageSize: queryKey[4] || FILES_PER_ROW,
  });
};

const postSearchFilesInFolder = (data: IFilesSearchInFolder) => {
  return tmsHTTPRequest.post(
    `/v1/files/search-in-folder-details/${data.folderId}`,
    {
      ...data,
      advancedSearch: { fields: ['Name'] },
    }
  );
};

export const middlewarePostSearchFilesInFolder = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return postSearchFilesInFolder({
    keyword: queryKey[1],
    folderId: queryKey[2],
    pageNumber: pageParam,
    fileType: queryKey[3],
    pageSize: queryKey[4] || FILES_PER_ROW,
  });
};
